/**
 * Фильтры спецификации: выпадающие списки по статусу/производителю.
 *
 * При смене чекбокса вызывает loadSpecTable() из table.js для перезагрузки таблицы.
 */

import { state } from './store.js';
import { loadSpecTable } from './table.js';

function updateFilterSelection(type, value, checked) {
    if (checked) {
        if (!state.selectedFilters[type].includes(value)) state.selectedFilters[type].push(value);
    } else {
        const index = state.selectedFilters[type].indexOf(value);
        if (index > -1) state.selectedFilters[type].splice(index, 1);
    }
}

export function initFilterHandlers() {
    const filterContainer = document.getElementById('adm_spec_settings');
    if (!filterContainer) return;

    // Клик по заголовку — открыть/закрыть dropdown
    filterContainer.addEventListener('click', e => {
        const caption = e.target.closest('[data-js-filter-caption]');
        if (!caption) return;

        e.stopPropagation();
        const filterItem = caption.closest('[data-js-filter-item]');
        const currentId = filterItem.getAttribute('data-js-filter-item');

        filterItem.classList.toggle('open');

        filterContainer.querySelectorAll('[data-js-filter-item]').forEach(item => {
            if (item.getAttribute('data-js-filter-item') !== currentId) {
                item.classList.remove('open');
            }
        });
    });

    // Смена чекбокса — обновить фильтр + перезагрузить таблицу
    filterContainer.addEventListener('change', e => {
        if (e.target.type !== 'checkbox') return;

        const type = e.target.dataset.type || e.target.name.replace('[]', '');
        if (type === 'status' || type === 'manufacturer') {
            updateFilterSelection(type, e.target.value, e.target.checked);
            loadSpecTable();
        }
    });

    // Клик вне области — закрыть все dropdown
    document.addEventListener('click', e => {
        if (!filterContainer.contains(e.target)) {
            filterContainer.querySelectorAll('[data-js-filter-item]').forEach(item => {
                item.classList.remove('open');
            });
        }
    });
}
